module.exports = __webpack_public_path__ + "static/RR4-dbf08574c68152da0e92aa8901b06335.jpg";